<button mat-icon-button class="large" (click)="onClick()">
    <mat-icon class="icon-mic">
        mic
    </mat-icon>
</button>
